// Band boundaries as a percentage of the way along the scale. On a 0–10 scale that is 0–2 negative, 3–6 neutral, and
// 7–10 positive. On a 1–5 scale it is 1–2 negative, 3 neutral, and 4–5 positive.
export const NEGATIVE_BAND_END_PERCENTAGE = 30;
export const POSITIVE_BAND_START_PERCENTAGE = 70;
